import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=47a7fb37"
import script from "./Sharing.vue?vue&type=script&lang=js"
export * from "./Sharing.vue?vue&type=script&lang=js"
import style0 from "./Sharing.vue?vue&type=style&index=0&id=47a7fb37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports